// extracted by mini-css-extract-plugin
module.exports = {"formats":"formats___1XKwT","format":"format___2Gweu","active":"active___2WnGQ"};